/* Dawly theme script = port of dawly\site-v2\site.js (mock-up, build_v2.py JS).
   Same UI: announcement rotator, carousels, mobile drawer, footer accordions, reels (tap = sound), gallery, bundle picker, sticky bar.
   Commerce is Shopify: bundle radio = variant id; BUY NOW! = POST /cart/add.js then /checkout; predictive search /search/suggest.json.
   Prices print with a dot (the shop money format prints a comma). */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var eur = function (c) { return '€' + (Number(c) / 100).toFixed(2); };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function strip(s) { var d = document.createElement('div'); d.innerHTML = s || ''; return (d.textContent || '').replace(/\s+/g, ' ').trim(); }

  /* announcement rotator */
  function announce() {
    var a = $('.announce'), el = a && $('.msg', a); if (!el) return;
    var m = []; try { m = JSON.parse(a.getAttribute('data-ann') || '[]').filter(function (x) { return x; }); } catch (e) { }
    if (m.length < 2) return;
    var i = 0, show = function (d) { i = (i + d + m.length) % m.length; el.innerHTML = m[i]; };
    $('.p', a).onclick = function () { show(-1); }; $('.n', a).onclick = function () { show(1); };
    setInterval(function () { show(1); }, 5000);
  }

  /* carousels */
  function carousels() {
    $$('.car').forEach(function (c) {
      var t = $('.track', c);
      $$('.arrow', c).forEach(function (a) { a.onclick = function () { t.scrollBy({ left: (a.classList.contains('l') ? -1 : 1) * t.clientWidth * 0.8, behavior: 'smooth' }); }; });
    });
  }

  /* mobile drawer + footer accordions */
  function drawer() {
    var dr = $('.drawer'); if (!dr) return;
    $$('.open-menu').forEach(function (b) { b.onclick = function () { dr.classList.add('open'); }; });
    $$('.close-menu').forEach(function (b) { b.onclick = function () { dr.classList.remove('open'); $$('.sub', dr).forEach(function (s) { s.classList.remove('open'); }); }; });
    $$('[data-sub]', dr).forEach(function (b) { b.onclick = function () { var s = document.getElementById(b.getAttribute('data-sub')); if (s) s.classList.add('open'); }; });
    $$('.sub .back', dr).forEach(function (b) { b.onclick = function () { b.closest('.sub').classList.remove('open'); }; });
    $$('a', dr).forEach(function (a) { a.addEventListener('click', function () { dr.classList.remove('open'); }); });
    if (window.matchMedia('(max-width:900px)').matches) $$('footer details').forEach(function (d) { d.open = false; });
  }

  /* reels: silent preview while visible; tap = play from start with sound + controls (others pause) */
  function reels() {
    var rs = $$('.reel'); if (!rs.length) return;
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
      es.forEach(function (e) { var v = e.target; if (v.closest('.reel').classList.contains('on')) return; if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () { }); } else v.pause(); });
    }, { threshold: 0.6 }) : null;
    rs.forEach(function (r) {
      var v = $('video', r); if (io) io.observe(v);
      var go = function () {
        $$('.reel.on').forEach(function (o) { if (o !== r) { var ov = $('video', o); ov.pause(); ov.muted = true; ov.controls = false; o.classList.remove('on'); } });
        if (r.classList.contains('on')) return;
        r.classList.add('on'); v.muted = false; v.currentTime = 0; v.controls = true; var p = v.play(); if (p && p.catch) p.catch(function () { });
      };
      $('.play', r).onclick = go; v.addEventListener('click', function () { if (!r.classList.contains('on')) go(); });
    });
  }

  /* accordions open on #does / #box / #specs / #faq links */
  function openHash() {
    var h = location.hash.slice(1); if (!h) return;
    var d = document.getElementById(h);
    if (d && d.tagName === 'DETAILS') { d.open = true; setTimeout(function () { d.scrollIntoView({ block: 'start' }); }, 50); }
  }

  /* product page */
  function product() {
    var pdp = $('[data-pdp]'); if (!pdp) return;
    var form = $('#dawly-form'), radios = $$('.packs input', pdp), qty = $('[data-qty]', form), main = $('#mainimg'), simg = $('[data-sticky-img]');
    var sel = function () { return radios.filter(function (r) { return r.checked; })[0] || radios[0]; };
    function paint(r) {
      $$('.js-price').forEach(function (p) { p.innerHTML = (r.getAttribute('data-old') ? '<s>' + esc(r.getAttribute('data-old')) + '</s> ' : '') + esc(r.getAttribute('data-price')); });
      if (main && r.getAttribute('data-img')) { main.src = r.getAttribute('data-img'); main.alt = r.getAttribute('data-alt') || main.alt; }
      if (simg && r.getAttribute('data-img-s')) simg.src = r.getAttribute('data-img-s');
      $$('.thumbs button').forEach(function (x, i) { x.classList.toggle('on', i === 0 && r.getAttribute('data-n') === '1'); });
      try { history.replaceState(null, '', location.pathname + '?variant=' + r.value + location.hash); } catch (e) { }
    }
    radios.forEach(function (r) { r.addEventListener('change', function () { paint(r); }); });
    var b = new URLSearchParams(location.search).get('b'), pre = b && $('.packs input[data-n="' + b + '"]', pdp);
    if (pre) { pre.checked = true; paint(pre); }
    $$('.thumbs button').forEach(function (t) {
      t.onclick = function () { main.src = t.getAttribute('data-src'); main.alt = t.getAttribute('data-alt'); $$('.thumbs button').forEach(function (x) { x.classList.toggle('on', x === t); }); };
    });
    $$('.qty button', pdp).forEach(function (bt) { bt.onclick = function () { qty.value = Math.max(1, (+qty.value || 1) + (+bt.getAttribute('data-d'))); }; });
    var busy = false;
    function toast(msg) {
      var t = $('.dawly-toast'); if (!t) { t = document.createElement('div'); t.className = 'dawly-toast'; document.body.appendChild(t); }
      t.innerHTML = msg; t.classList.add('show'); clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('show'); }, 4500);
    }
    function buyNow(go) {
      if (busy) return; busy = true;
      var r = sel(), q = Math.max(1, parseInt(qty.value, 10) || 1);
      $$('[data-buy],[data-buy-sticky],[data-add]').forEach(function (x) { x.setAttribute('aria-busy', 'true'); });
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +r.value, quantity: q }] }) })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          if (go !== false) { location.href = '/checkout'; return; }
          busy = false; $$('[data-buy],[data-buy-sticky],[data-add]').forEach(function (x) { x.removeAttribute('aria-busy'); });
          return fetch('/cart.js').then(function (c) { return c.json(); }).then(function (c) {
            $$('[data-cart-count]').forEach(function (x) { x.textContent = c.item_count; });
            var lab = (r.closest('label') && $('.q', r.closest('label'))) ? $('.q', r.closest('label')).textContent.trim() : 'Dawly';
            toast('<b>Added to cart:</b> ' + q + ' &times; ' + lab + '<span><a href="/cart">View cart</a><a href="/checkout" class="go">Checkout</a></span>');
          });
        })
        .catch(function () { busy = false; if (go !== false) form.submit(); else toast('Could not add to cart. Please try again.'); });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); buyNow(true); });
    $$('[data-buy-sticky]').forEach(function (x) { x.addEventListener('click', function () { buyNow(true); }); });
    $$('[data-add]', pdp).forEach(function (x) { x.addEventListener('click', function () { buyNow(false); }); });
    var st = $('.sticky'), bb = $('.buy', pdp);
    if (st && bb && 'IntersectionObserver' in window) new IntersectionObserver(function (es) { var e = es[0]; st.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0); }).observe(bb);
  }

  /* predictive search overlay */
  var ov, liveP;
  function liveProducts() {
    if (!liveP) liveP = fetch('/collections/all/products.json?limit=50').then(function (r) { return r.json(); }).then(function (j) {
      var m = {}; (j.products || []).forEach(function (p) { m[p.handle] = p; }); return { list: j.products || [], byHandle: m };
    }).catch(function () { return { list: [], byHandle: {} }; });
    return liveP;
  }
  function openSearch() {
    if (!ov) {
      ov = document.createElement('div'); ov.className = 'sov'; ov.hidden = true;
      ov.innerHTML = '<div class="pnl" role="dialog" aria-modal="true" aria-label="Search"><div class="top"><h3>Search</h3><button type="button" class="icon-b" data-x aria-label="Close search"><svg viewBox="0 0 24 24"><path d="M5 5l14 14M19 5L5 19"/></svg></button></div>' +
        '<form class="sform" action="/search" method="get" role="search"><input type="search" name="q" placeholder="Search: delivery, colours, battery…" autocomplete="off" aria-label="Search the shop"><input type="hidden" name="type" value="product,page"><button type="submit">SEARCH</button></form><div class="sres" aria-live="polite"></div></div>';
      document.body.appendChild(ov);
      ov.addEventListener('click', function (e) { if (e.target === ov || e.target.closest('[data-x]')) closeSearch(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !ov.hidden) closeSearch(); });
      var inp = $('input[name=q]', ov), res = $('.sres', ov), seq = 0, timer;
      var run = function () {
        var q = inp.value.trim(), my = ++seq;
        if (!q) { res.innerHTML = ''; return; }
        Promise.all([fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,page&resources[limit]=6&resources[limit_scope]=each&resources[options][fields]=title,body,product_type,tag,variants.title')
          .then(function (r) { return r.json(); }), liveProducts()]).then(function (all) {
            if (my !== seq) return;
            var j = all[0], live = all[1], r = (j.resources && j.resources.results) || {}, hits = [], seen = {};
            var words = q.toLowerCase().split(/\s+/).filter(Boolean);
            /* Shopify's product index can lag: keep only live products, add live products that match every word */
            var prods = (r.products || []).filter(function (p) { return live.byHandle[p.handle]; }).map(function (p) { return live.byHandle[p.handle]; });
            live.list.forEach(function (p) { var hay = (p.title + ' ' + strip(p.body_html) + ' ' + (p.tags || []).join(' ') + ' ' + p.product_type).toLowerCase(); if (words.every(function (w) { return hay.indexOf(w) >= 0; })) prods.push(p); });
            prods.forEach(function (p) {
              if (seen[p.handle]) return; seen[p.handle] = 1;
              var img = p.images && p.images[0] && p.images[0].src, min = Math.min.apply(null, p.variants.map(function (v) { return Math.round(parseFloat(v.price) * 100); }));
              hits.push('<a class="shit" href="/products/' + esc(p.handle) + '">' + (img ? '<img src="' + esc(img) + (img.indexOf('?') >= 0 ? '&' : '?') + 'width=120" alt="" width="56" height="56">' : '') + '<span><span class="k">Product</span><strong>' + esc(p.title) + '</strong><small>from ' + eur(min) + '</small></span></a>');
            });
            (r.pages || []).forEach(function (p) { hits.push('<a class="shit" href="' + esc(p.url) + '"><span><span class="k">Help</span><strong>' + esc(p.title) + '</strong><small>' + esc(strip(p.body).slice(0, 120)) + '</small></span></a>'); });
            res.innerHTML = hits.length ? hits.join('') + '<a class="more" href="/search?type=product,page&q=' + encodeURIComponent(q) + '">All results</a>' : '<p class="smuted">Nothing matches “' + esc(q) + '”. Try “delivery” or “returns”.</p>';
          }).catch(function () { if (my === seq) res.innerHTML = '<p class="smuted">Press Enter to search.</p>'; });
      };
      inp.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 160); });
    }
    var d = $('.drawer'); if (d) d.classList.remove('open');
    ov.hidden = false; document.body.classList.add('ov-open'); setTimeout(function () { $('input[name=q]', ov).focus(); }, 30);
  }
  function closeSearch() { ov.hidden = true; document.body.classList.remove('ov-open'); }
  function search() { $$('[data-search-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openSearch(); }); }); }

  /* cart count stays right after the back button (bfcache) */
  function count() {
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { $$('[data-cart-count]').forEach(function (x) { x.textContent = c.item_count; }); }).catch(function () { });
    });
  }

  function boot() { announce(); carousels(); drawer(); reels(); product(); search(); count(); openHash(); window.addEventListener('hashchange', openHash); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
